import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import './Admissions.css';
import NewAdmission from './NewAdmission';
import AdmissionsListTable from './AdmissionsListTable';
import PatientInfoPanel from './PatientInfoPanel/PatientInfoPanel';
import ENDPOINTS, { API_BASE_URL } from '../../Constants/ApiEndpoints';
import axios from 'axios';

const Admissions = () => {
  const [startDate, setStartDate] = useState(new Date('1970-01-01'));
  const [endDate, setEndDate] = useState(new Date());
  const [admissionFilters, setAdmissionFilters] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [patient, setPatient] = useState(location.state?.patient || null);
  const [loadingPatient, setLoadingPatient] = useState(!patient && !!id);

  const isNewAdmission = location.pathname.endsWith('/newAdmission');
  const isPatientView = location.pathname.includes('/patientInfoPanel/');

  useEffect(() => {
    if (location.state?.patient) {
      setPatient(location.state.patient);
      setLoadingPatient(false);
    }

    const fetchPatientById = async () => {
      try {
        if (!location.state?.patient) {
          setLoadingPatient(true);
        }
        const endpoint = ENDPOINTS.GET_ADMISSION_DETAILS_BY_ADMISSION_ID || `${API_BASE_URL}/getAdmissionDetailsByAdmissionId`;
        const response = await axios.get(`${endpoint}/${id}`);
        if (response.data) {
          setPatient(response.data);
        }
      } catch (error) {
        console.error('Failed to load admission details', error);
      } finally {
        setLoadingPatient(false);
      }
    };

    if (id && !location.state?.patient) {
      fetchPatientById();
    }
  }, [id, location.state]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setAdmissionFilters(null); // reset search when date changes
  };

  const handleSearch = ({ type, query }) => {
    setAdmissionFilters({ type, query });
  };

  if (isNewAdmission) {
    return <NewAdmission onBack={() => navigate(-1)} />;
  }

  if (isPatientView) {
    if (loadingPatient) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
          Loading admission data...
        </div>
      );
    }

    if (patient) {
      return (
        <PatientInfoPanel
          patient={patient}
          onBack={() => navigate('/inpatient/admissions')}
        />
      );
    }

    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
        Admission Info not found.
      </div>
    );
  }

  return (
    <div className="admissions-page-wrapper">
      <AdmissionsListTable
        startDate={startDate}
        endDate={endDate}
        onDateChange={handleDateChange}
        onSearch={handleSearch}
        admissionFilters={admissionFilters}
        onNewAdmission={() => navigate('/inpatient/admissions/newAdmission')}
        onSelectPatient={(patient) =>
          navigate(`/inpatient/admissions/patientInfoPanel/${patient.admissionId || patient.id || patient.mrNumber}`, {
            state: { patient },
          })
        }
      />
    </div>
  );
};

export default Admissions;
